<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否删除0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="商品名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入商品名称" v-trim/>
      </el-form-item>
      <el-form-item label="京东sku" prop="sku">
        <el-input v-model="form.sku" placeholder="请输入京东sku" v-trim/>
      </el-form-item>
      <el-form-item label="品牌" prop="brand">
        <el-input v-model="form.brand" placeholder="请输入品牌" v-trim/>
      </el-form-item>
      <el-form-item label="类别" prop="category">
        <el-input v-model="form.category" placeholder="请输入类别" v-trim/>
      </el-form-item>
      <el-form-item label="外链地址" prop="url">
        <el-input v-model="form.url" placeholder="请输入外链地址" v-trim/>
      </el-form-item>
      <el-form-item label="列表图" prop="imgurl">
        <el-input v-model="form.imgurl" placeholder="请输入列表图" v-trim/>
      </el-form-item>
      <el-form-item label="大图1" prop="bgImg">
        <el-input v-model="form.bgImg" placeholder="请输入大图1" v-trim/>
      </el-form-item>
      <el-form-item label="大图2" prop="bgImg2">
        <el-input v-model="form.bgImg2" placeholder="请输入大图2" v-trim/>
      </el-form-item>
      <el-form-item label="大图3" prop="bgImg3">
        <el-input v-model="form.bgImg3" placeholder="请输入大图3" v-trim/>
      </el-form-item>
      <el-form-item label="价格" prop="price">
        <el-input v-model="form.price" placeholder="请输入价格" v-trim/>
      </el-form-item>
      <el-form-item label="采购价格" prop="saleprice">
        <el-input v-model="form.saleprice" placeholder="请输入采购价格" v-trim/>
      </el-form-item>
      <el-form-item label="属性1" prop="attr1">
        <el-input v-model="form.attr1" placeholder="请输入属性1" v-trim/>
      </el-form-item>
      <el-form-item label="属性2" prop="attr2">
        <el-input v-model="form.attr2" placeholder="请输入属性2" v-trim/>
      </el-form-item>
      <el-form-item label="属性3" prop="attr3">
        <el-input v-model="form.attr3" placeholder="请输入属性3" v-trim/>
      </el-form-item>
      <el-form-item label="属性4" prop="attr4">
        <el-input v-model="form.attr4" placeholder="请输入属性4" v-trim/>
      </el-form-item>
      <el-form-item label="属性5" prop="attr5">
        <el-input v-model="form.attr5" placeholder="请输入属性5" v-trim/>
      </el-form-item>
      <el-form-item label="属性6" prop="attr6">
        <el-input v-model="form.attr6" placeholder="请输入属性6" v-trim/>
      </el-form-item>
      <el-form-item label="属性7" prop="attr7">
        <el-input v-model="form.attr7" placeholder="请输入属性7" v-trim/>
      </el-form-item>
      <el-form-item label="属性8" prop="attr8">
        <el-input v-model="form.attr8" placeholder="请输入属性8" v-trim/>
      </el-form-item>
      <el-form-item label="属性9" prop="attr9">
        <el-input v-model="form.attr9" placeholder="请输入属性9" v-trim/>
      </el-form-item>
      <el-form-item label="属性10" prop="attr10">
        <el-input v-model="form.attr10" placeholder="请输入属性10" v-trim/>
      </el-form-item>
      <el-form-item label="属性11" prop="attr11">
        <el-input v-model="form.attr11" placeholder="请输入属性11" v-trim/>
      </el-form-item>
      <el-form-item label="属性12" prop="attr12">
        <el-input v-model="form.attr12" placeholder="请输入属性12" v-trim/>
      </el-form-item>
      <el-form-item label="属性13" prop="attr13">
        <el-input v-model="form.attr13" placeholder="请输入属性13" v-trim/>
      </el-form-item>
      <el-form-item label="属性14" prop="attr14">
        <el-input v-model="form.attr14" placeholder="请输入属性14" v-trim/>
      </el-form-item>
      <el-form-item label="属性15" prop="attr15">
        <el-input v-model="form.attr15" placeholder="请输入属性15" v-trim/>
      </el-form-item>
      <el-form-item label="属性16" prop="attr16">
        <el-input v-model="form.attr16" placeholder="请输入属性16" v-trim/>
      </el-form-item>
      <el-form-item label="属性17" prop="attr17">
        <el-input v-model="form.attr17" placeholder="请输入属性17" v-trim/>
      </el-form-item>
      <el-form-item label="属性18" prop="attr18">
        <el-input v-model="form.attr18" placeholder="请输入属性18" v-trim/>
      </el-form-item>
      <el-form-item label="属性19" prop="attr19">
        <el-input v-model="form.attr19" placeholder="请输入属性19" v-trim/>
      </el-form-item>
      <el-form-item label="属性20" prop="attr20">
        <el-input v-model="form.attr20" placeholder="请输入属性20" v-trim/>
      </el-form-item>
      <el-form-item label="属性21" prop="attr21">
        <el-input v-model="form.attr21" placeholder="请输入属性21" v-trim/>
      </el-form-item>
      <el-form-item label="属性22" prop="attr22">
        <el-input v-model="form.attr22" placeholder="请输入属性22" v-trim/>
      </el-form-item>
      <el-form-item label="属性23" prop="attr23">
        <el-input v-model="form.attr23" placeholder="请输入属性23" v-trim/>
      </el-form-item>
      <el-form-item label="属性24" prop="attr24">
        <el-input v-model="form.attr24" placeholder="请输入属性24" v-trim/>
      </el-form-item>
      <el-form-item label="属性25" prop="attr25">
        <el-input v-model="form.attr25" placeholder="请输入属性25" v-trim/>
      </el-form-item>
      <el-form-item label="属性26" prop="attr26">
        <el-input v-model="form.attr26" placeholder="请输入属性26" v-trim/>
      </el-form-item>
      <el-form-item label="属性27" prop="attr27">
        <el-input v-model="form.attr27" placeholder="请输入属性27" v-trim/>
      </el-form-item>
      <el-form-item label="属性28" prop="attr28">
        <el-input v-model="form.attr28" placeholder="请输入属性28" v-trim/>
      </el-form-item>
      <el-form-item label="属性29" prop="attr29">
        <el-input v-model="form.attr29" placeholder="请输入属性29" v-trim/>
      </el-form-item>
      <el-form-item label="属性30" prop="attr30">
        <el-input v-model="form.attr30" placeholder="请输入属性30" v-trim/>
      </el-form-item>
      <el-form-item label="属性31" prop="attr31">
        <el-input v-model="form.attr31" placeholder="请输入属性31" v-trim/>
      </el-form-item>
      <el-form-item label="属性32" prop="attr32">
        <el-input v-model="form.attr32" placeholder="请输入属性32" v-trim/>
      </el-form-item>
      <el-form-item label="属性33" prop="attr33">
        <el-input v-model="form.attr33" placeholder="请输入属性33" v-trim/>
      </el-form-item>
      <el-form-item label="属性34" prop="attr34">
        <el-input v-model="form.attr34" placeholder="请输入属性34" v-trim/>
      </el-form-item>
      <el-form-item label="处理状态 0待处理 1已处理" prop="status">
        <el-input v-model="form.status" placeholder="请输入处理状态 0待处理 1已处理" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaBaseDataWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        title: '',
        name: '',
        sku: '',
        brand: '',
        category: '',
        url: '',
        imgurl: '',
        bgImg: '',
        bgImg2: '',
        bgImg3: '',
        price: '',
        saleprice: '',
        attr1: '',
        attr2: '',
        attr3: '',
        attr4: '',
        attr5: '',
        attr6: '',
        attr7: '',
        attr8: '',
        attr9: '',
        attr10: '',
        attr11: '',
        attr12: '',
        attr13: '',
        attr14: '',
        attr15: '',
        attr16: '',
        attr17: '',
        attr18: '',
        attr19: '',
        attr20: '',
        attr21: '',
        attr22: '',
        attr23: '',
        attr24: '',
        attr25: '',
        attr26: '',
        attr27: '',
        attr28: '',
        attr29: '',
        attr30: '',
        attr31: '',
        attr32: '',
        attr33: '',
        attr34: '',
        status: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/baseData',
      'field.id': 'id'
    })
  }
}
</script>
